import {jsx} from 'panel';

export function EmptyData() {
  return (
    <div sel='.empty-data' attrs={{elref: `emptyData`}}>
      <div sel='.empty-data-image-wrapper' />
      <div sel='.empty-data-text'>No data for this report</div>
    </div>
  );
}
